import React from "react";

const DestinoLogoEvertec = () => {
  return (
    <img
      className={"mb-2 mt-8"}
      src={`https://static.placetopay.com/placetopay-logo.svg`}
      alt={"LogoPasarela"}
    />
  );
};

export default DestinoLogoEvertec;
